module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question2.45f0c54e.jpg";